export enum ExportType {
  MEMBER = "member",
  MEMBER_SEGMENT = "memberSegment",
  MEMBER_TIER = "memberTier",
  CAMPAIGN_CODE = "campaignCode",
  REWARD_FULFILLMENT = "rewardFulfillment",
}

export type ExportTypeUnion = `${ExportType}`;

export type FilterCriteria = {
  [key: string]: string | number | boolean | { [key: string]: string };
};

export enum ExportStatus {
  DONE = "done",
  ERROR = "error",
  PENDING = "pending",
  IN_PROGRESS = "inprogress",
}

type ExportStatusUnion = `${ExportStatus}`;

export type ExportListItem = {
  exportId: string;
  type: ExportType;
  status: ExportStatusUnion;
  createdAt: string;
  finishedAt: string;
  endDate: string;
  exportedRows: number;
  criteria: string;
};

export type ExportDataKeys = Exclude<keyof ExportListItem, "criteria">;

export type FilterLabelWithId = {
  id: string;
  label: string;
};

export enum DateOperators {
  LESS = "lt",
  LESS_OR_EQUAL = "lte",
  GREATER = "gt",
  GREATER_OR_EQUAL = "gte",
}
type DateOperatorsUnion = `${DateOperators}`;

export type DateFilterValue = Record<DateOperatorsUnion, string>;
